const nf = new Intl.NumberFormat('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const num2 = (x: number) => nf.format(x);
export const money = (x: number | null | undefined) => (x == null ? '—' : nf.format(x) + ' zł');
export const amtCur = (x: number | string | null | undefined, c?: string) =>
  x == null || x === '' ? '—' : nf.format(Number(x)) + ' ' + (c || '');
export const rateF = (x: number | null | undefined) =>
  x == null ? '—' : Number(x).toLocaleString('pl-PL', { minimumFractionDigits: 4, maximumFractionDigits: 4 });

/** Odmiana: 1 faktura, 2 faktury, 5 faktur, 22 faktury */
export function plural(n: number, one: string, few: string, many: string): string {
  if (n === 1) return one;
  const d = n % 10, dd = n % 100;
  return d >= 2 && d <= 4 && !(dd >= 12 && dd <= 14) ? few : many;
}

/** Liczba z polskim przecinkiem i spacjami („1 234,56”) albo z kropką. */
/**
 * Kwota wpisana przez człowieka: „1599,71”, „1 599,71”, „1.599,71”, „1,599.71”, „227.40”.
 * Gdy są oba separatory, dziesiętny jest ostatni. Sam przecinek jest dziesiętny (zapis polski).
 * Jedna kropka i dokładnie trzy cyfry („4.000”) to 4000 albo 4 – zamiast zgadywać, zwraca null.
 */
export function parseAmount(s: string | number | null | undefined): number | null {
  if (s == null) return null;
  if (typeof s === 'number') return Number.isFinite(s) ? s : null;
  const m = /^(-?)([\d.,]+)$/.exec(s.replace(/[\s\u00a0\u202f]/g, ''));
  if (!m) return null;
  const [, sign, body] = m;
  const dot = body.lastIndexOf('.'), comma = body.lastIndexOf(',');
  let int: string, frac = '';
  if (dot >= 0 && comma >= 0) {
    const [dec, thou] = dot > comma ? ['.', ','] : [',', '.'];
    const parts = body.split(dec);
    if (parts.length !== 2 || !new RegExp(`^\\d{1,3}(\\${thou}\\d{3})*$`).test(parts[0])) return null;
    int = parts[0].split(thou).join('');
    frac = parts[1];
  } else if (comma >= 0) {
    const parts = body.split(',');
    if (parts.length !== 2) return null;
    [int, frac] = parts;
  } else if (dot >= 0) {
    const parts = body.split('.');
    if (parts.length > 2) {
      if (!/^\d{1,3}(\.\d{3})+$/.test(body)) return null;
      int = parts.join('');
    } else {
      [int, frac] = parts;
      if (frac.length === 3 && /^[1-9]\d{0,2}$/.test(int)) return null;
    }
  } else {
    int = body;
  }
  if (!/^\d*$/.test(int) || !/^\d*$/.test(frac) || int + frac === '') return null;
  return Number(`${sign}${int || '0'}.${frac || '0'}`);
}

export const CYCLE_LABEL: Record<string, string> = { monthly: 'co miesiąc', annual: 'co rok', usage: 'za zużycie', irregular: 'nieregularnie' };
export const TIMING_LABEL: Record<string, string> = { prepaid: 'z góry', arrears: 'z dołu' };
export const VATID_LABEL: Record<string, string> = { yes: 'ma Twój VAT-UE', no: 'nie ma VAT-UE', unknown: 'nie wiadomo' };
export const STATUS_LABEL: Record<string, string> = { draft: 'Szkic do uzupełnienia', new: 'Do wysłania do biura', sent: 'Wysłana do biura', booked: 'Zaksięgowana' };
